import ProffessionalTags from './tags/ProffesionalTags';

function Professional() {
  return (
    <div>
      <ProffessionalTags />
    </div>
  );
}

export default Professional;
